module.exports = __webpack_public_path__ + "static/media/Experience Research.5d6860f1.csv";